export default __webpack_public_path__ + "fonts/tpl_3.a18bcec3dc114a58f3c12ae61ad5e58f.png";